import React from "react";
import { Grid, Segment } from "semantic-ui-react";
import { Button } from "antd";
import "../auth.css";
import { connect } from "react-redux";
import { selectedlanguage } from "../actions";
import i18n from "../i18n";
import { reactLocalStorage } from "reactjs-localstorage";
import { Link } from "react-router-dom";

class Logo extends React.Component {
  constructor(props) {
    super(props);
    this.state = { lng: "en" };
  }

  onLanguageChanged = () => {
    if (this.state.lng === "ar") {
      this.setState({ lng: "en" });
      this.props.selectedlanguage("en");
      i18n.changeLanguage("en");
      reactLocalStorage.set("lang", "en");
      window.location = window.location.origin + "/app/";
    } else {
      this.setState({ lng: "ar" });
      this.props.selectedlanguage("ar");
      i18n.changeLanguage("ar");
      reactLocalStorage.set("lang", "ar");
      window.location = window.location.origin + "/app/";
    }
  };
  componentWillMount() {
    /* var lang=i18n.language;
     if(lang ==="ar")
     {
     }*/
    if (reactLocalStorage.get("lang") === "ar") {
      this.setState({ lng: "ar" });
      this.props.selectedlanguage("ar");
    } else {
      this.setState({ lng: "en" });
      this.props.selectedlanguage("en");
    }
  }

  render() {
    return (
      <div className="container">
        <Grid columns={2} divided>
          <Grid.Row stretched className="main_row_header">
            <Grid.Column className="grid_logo">
              <Segment>
                <Link to="/app">
                  <img
                    src={require("../pictures/ZB logo-02.png")}
                    className="Logo"
                    alt="logo"
                    style={{ cursor: "pointer",  width: '30%' }}
                  />
                </Link>
              </Segment>
            </Grid.Column>

            <Grid.Column className="grid_language">
              <Segment className="segment_data header_mobile">
                <Button
                  className="btn_lang btn_data"
                  style={{ margin: "3%" }}
                  onClick={this.onLanguageChanged}
                >
                  {this.state.lng === "en" ? "عربي" : "ENGLISH"}
                </Button>
                <Link to="/app/ContactUS">
                  <Button
                    className="btn_lang btn_data btn_contact"
                    style={{ margin: "1%", width: "auto" }}
                  >
                    {i18n.t("contact_us.label")}{" "}
                  </Button>
                </Link>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {

  return { language: state.language };
};

export default connect(
  mapStateToProps,
  { selectedlanguage }
)(Logo);
